"use client";
import Script from "next/script";
import * as Sentry from "@sentry/nextjs";
import { retryScript } from "./RetryScript";
import { getJornayaLeadId, notifyJornayaLeadIdAvailable } from "../hooks/useJornaya";

const jornayaScriptId = "jornaya-script";
const jornayaCampaignId = process.env.JORNAYA_CAMPAIGN_ID;
const JORNAYA_TOKEN_POLL_MS = 500;
const JORNAYA_TOKEN_POLL_ATTEMPTS = 60;
const JORNAYA_TIMEOUT_MS = JORNAYA_TOKEN_POLL_MS * JORNAYA_TOKEN_POLL_ATTEMPTS;

let tokenPollInterval: number | undefined;
let hasCapturedJornayaLeadId = false;
let hasReportedJornayaTimeout = false;

const clearTokenPollInterval = () => {
  if (tokenPollInterval === undefined) return;
  window.clearInterval(tokenPollInterval);
  tokenPollInterval = undefined;
};

const pollForJornayaLeadId = () => {
  clearTokenPollInterval();

  if (getJornayaLeadId()) {
    hasCapturedJornayaLeadId = true;
    notifyJornayaLeadIdAvailable();
    return;
  }

  let attempts = 0;
  tokenPollInterval = window.setInterval(() => {
    attempts += 1;
    if (getJornayaLeadId()) {
      hasCapturedJornayaLeadId = true;
      notifyJornayaLeadIdAvailable();
      clearTokenPollInterval();
      return;
    }

    if (attempts >= JORNAYA_TOKEN_POLL_ATTEMPTS) {
      clearTokenPollInterval();
      if (!hasCapturedJornayaLeadId && !hasReportedJornayaTimeout) {
        hasReportedJornayaTimeout = true;
        Sentry.captureMessage("Jornaya LeadID polling timeout", {
          level: "warning",
          tags: { feature: "jornaya", scenario: "compliance-timeout" },
          extra: {
            trackingType: "jornaya",
            timeoutMs: JORNAYA_TIMEOUT_MS,
          },
        });
      }
    }
  }, JORNAYA_TOKEN_POLL_MS);
};

const onLoad = () => {
  setTimeout(() => {
    if (!window.LeadiD) {
      retryScript(jornayaScriptId, onLoad);
      return;
    }
    pollForJornayaLeadId();
  }, 500);
};

export const JornayaScript = () => {
  if (!jornayaCampaignId) return null;

  return (
    <Script
      id={jornayaScriptId}
      strategy="afterInteractive"
      src={`//create.lidstatic.com/campaign/${jornayaCampaignId}.js?snippet_version=2`}
      onLoad={onLoad}
      onError={() => retryScript(jornayaScriptId, onLoad)}
    />
  );
};
